import { FLAG } from '@shared/products-types';

import type { Dashboard } from '../../types/Dashboard';

export const dashboardCZFeatureConfig: Dashboard = {
    hidePerformanceForFlags: [FLAG.consignmentContractAcc, FLAG.assetManagementAcc],
    hideSettingsForFlags: [],
};
